<template>
  <v-container fluid class="px-0">
    <v-row>
      <v-col>
        <pre-screened-patients-trending-graph
          :edited-site="editedSite"
          :org-trial-external-id="orgTrialExternalId"
          :trial-id="selectedTrialId"
          :trial-external-id="trialExternalId"
          :selected-trial-name="selectedTrialName"
        />
      </v-col>
      <v-col>
        <average-reviewed-trending-graph
          :edited-site="editedSite"
          :org-trial-external-id="orgTrialExternalId"
          :trial-id="selectedTrialId"
          :trial-external-id="trialExternalId"
          :selected-trial-name="selectedTrialName"
        />
      </v-col>
    </v-row>
    <trial-trending-graph
      :edited-site="editedSite"
      :org-trial-external-id="orgTrialExternalId"
      :trial-id="selectedTrialId"
      :trial-external-id="trialExternalId"
      :include-site-in-title="true"
      :pre-selected-graph-type="preSelectedGraphType"
      :pre-selected-traces="preSelectedTraces"
      :selected-table="selectedTable"
      :selected-trial-name="selectedTrialName"
      @graph-type-change="onGraphTypeChange"
      @update-traces="evt => $emit('update-traces', evt)"
    />
  </v-container>
</template>

<script>
import { TableTypes } from '@/helpers/table-helper'
import TrialTrendingGraph from '@/components/insights/TrialTrendingGraph'
import PreScreenedPatientsTrendingGraph from '@/components/insights/PreScreenedPatientsTrendingGraph'
import AverageReviewedTrendingGraph from '@/components/insights/AverageReviewedTrendingGraph'

export default {
  components: {
    AverageReviewedTrendingGraph,
    PreScreenedPatientsTrendingGraph,
    TrialTrendingGraph
  },
  props: {
    editedSite: { type: Object, default: null },
    selectedTable: { type: String, default: TableTypes.SUMMARY },
    preSelectedGraphType: { type: String, required: true },
    preSelectedTraces: { type: Array, default: () => [] },
    selectedTrialId: { type: String, default: null },
    selectedTrialName: { type: String, default: '' },
    trialExternalId: { type: String, default: null },
    summaries: { type: Array, default: () => [] },
    orgTrialExternalId: { type: String, default: null }
  },
  methods: {
    onGraphTypeChange(graphType) {
      this.$emit('graph-type-change', graphType)
    }
  }
}
</script>
